import { createContext, useContext } from "react";

// Mirrors the Signers `<fieldset disabled>` state for controls the fieldset
// can't reach natively:
//   - Radix Select triggers — Radix derives disabled from its own `disabled`
//     prop only (`isDisabled = context.disabled || disabled`), never from an
//     ancestor disabled fieldset, so a locked deal would leave them operable.
//   - The tel: call anchor in PhoneRow — an <a> is not a form control.
// Defaults to false (editable) so a control rendered outside the provider — or
// in an isolated unit test — behaves normally.
const ReadOnlyContext = createContext(false);

export const ReadOnlyProvider = ReadOnlyContext.Provider;

/**
 * Whether the enclosing Signers form is read-only (the VLA In-Use lock is held
 * by another analyst, still acquiring, or errored). Fed from the same `readOnly`
 * prop that drives the fieldset, which ReviewPage derives from `useReadOnly()`.
 * @returns {boolean} True when editable controls should be disabled.
 */
export function useFormReadOnly(): boolean {
  return useContext(ReadOnlyContext);
}
